export default {
    MEDIA_TYPES: {
        OTHER: {id: 0, name: "Other", title: "Other"},
        IMAGE: {id: 1, name: "Image", title: "Images"},
        VIDEO: {id: 2, name: "Video", title: "Videos"},
        DOCUMENT: {id: 3, name: "Document", title: "Documents"},
        SPREADSHEET: {id: 4, name: "Spreadsheet", title: "Spreadsheets"},
        PRESENTATION: {id: 5, name: "Presentation", title: "Presentations"},
        ARCHIVE: {id: 6, name: "Archive", title: "Archives"},
        EXTERNAL_RESOURCE: {id: 7, name: "ExternalResource", title: "External resources"}
    },
    EXTERNAL_CONTENT_TYPE: {
        UNKNOW: {id: 0, name: "Unknown", title: "Unknown"},
        YOUTUBE: {id: 1, name: "Youtube", title: "Youtube"},
        VIMEO: {id: 2, name: "Vimeo", title: "Vimeo"}
    },
    URL:{
        CORE_COMPETENCES:"https://electrolux.sharepoint.com/sites/GrowWithElectrolux/SitePages/Our-Culture.aspx",
        KEY_SKILLS: "https://electrolux.sharepoint.com/Pages/InformationPage.aspx?cmsPageId=22070",
        EMPLOYEE:{
            CORE_COMPETENCES:"https://electrolux.sharepoint.com/sites/GrowWithElectrolux/SitePages/Our-Culture.aspx",
            KEY_SKILLS:"https://electrolux.sharepoint.com/sites/cms/hr/performance/functional-skills"
        }
    }
};



// WEBPACK FOOTER //
// ./src/config/constants.js